package org.bsvac.bsvac_kmp.data.models

data class LogonOptionModel(
    val unitOptions: List<AmbulanceUnitModel>,
    val boroughOptions: List<BoroughModel>,
    val tourOptions: List<TourModel>,
    val crewOptions: List<CrewModel>,
    val radioOptions: List<RadioModel>
) {
    companion object {
        val EMPTY: LogonOptionModel = LogonOptionModel(
            unitOptions = emptyList(),
            boroughOptions = emptyList(),
            tourOptions = emptyList(),
            crewOptions = emptyList(),
            radioOptions = emptyList()
        )
    }
}